import { isDevMode } from '@angular/core';
import { CanMatchFn } from '@angular/router';

export function isLoopbackHost(hostname: string): boolean {
    return ['localhost', '127.0.0.1', '::1', '[::1]'].includes(hostname.toLowerCase());
}

export function isLocalPlaywrightHarnessPath(pathname: string, hostname: string, devMode = isDevMode()): boolean {
    const normalizedPath = pathname.replace(/\/+$/, '').toLowerCase();
    return devMode && isLoopbackHost(hostname) && normalizedPath.startsWith('/__playwright/');
}

export const canMatchLocalPlaywrightHarness: CanMatchFn = () => {
    const currentLocation = globalThis.location;
    return !!currentLocation && isLocalPlaywrightHarnessPath(currentLocation.pathname, currentLocation.hostname);
};
